module.exports = __webpack_public_path__ + "img/ANTENNA 2 BW.878831a.svg";